/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2021 Deere & Company

import PropTypes from 'prop-types';
import React from 'react';

const EditableField = (props) => props.isEditable ?
    props.children : (
        <span className={props.className}>
            {props.value}
        </span>
    );

EditableField.displayName = 'EditableField';
EditableField.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default EditableField;
